module.exports = __webpack_public_path__ + "statics/img/editiontop.64d5365d.png";